
<template>
<!-- 新建空白答题卡 -->
  <div class="modal-card-empty">
    <el-dialog
      title="新建空白答题卡"
      :visible.sync="dialogVisible"
      width="40%"
      custom-class="dialog_empty_add"
      >
      <el-form :model="formdata" :rules="rules" ref="ruleForm">
        <el-form-item label="答题卡名称: " :label-width="formLabelWidth" prop="acCardName">
          <el-input v-model="formdata.acCardName" autocomplete="off" show-word-limit maxlength=50 style="width: 300px !important"></el-input>
        </el-form-item>
        <el-form-item label="答题卡布局/类型: " :label-width="formLabelWidth" prop="Panes">
          <el-select v-model="formdata.Panes" placeholder="请选择答题卡布局/类型">
            <el-option label="一栏（A4/B5/16K）" value="1"></el-option>
            <el-option label="二栏（A3/B4/8K）" value="2"></el-option>
            <el-option label="三栏（A3/B4/8K）" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="评阅方式: " :label-width="formLabelWidth" prop="YjType">
          <el-select v-model="formdata.YjType" placeholder="请选择评阅方式">
            <el-option label="网阅" value="1"></el-option>
            <el-option label="手批" value="0"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel('cancel')">取 消</el-button>
        <el-button type="primary" @click="handleSubmit('ruleForm')" :loading="btnLoading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import makeCard from "@/services/makeCard";

export default {
  props:{
    open: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      formLabelWidth: '160px',
      dialogVisible: false,
      formdata: {
        acCardName: '',
        YjType: '1', //评阅方式： 0、手批，1、网阅
        Panes: '1', //布局：1、一栏，2、二栏，3三栏
      },
      rules: {
        acCardName: [
            { required: true, message: '请输入答题卡名称', trigger: 'blur' },
            // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
          ],
        Panes: [
          { required: true, message: '请选择答题卡布局/类型', trigger: 'change' }
        ],
        YjType: [
          { required: true, message: '请选择评阅方式', trigger: 'change' }
        ],
      },
      btnLoading: false,
    }
  },
  methods: {
    handleSubmit(formName) {
       this.$refs[formName].validate((valid) => {
         if(valid) {
          // 防抖或者加入loading 这里避免对数据库秒级插入多条数据
          // this.btnLoading = true;
          this.$emit('saveCard', this.formdata);
          //  this.dialogVisible = false;
         } 
       })
    },
    handleCancel(name) {
      if(name == 'cancel') {
        this.dialogVisible = false;
        this.$emit('onChange', 'cancel');
      } else {
        this.dialogVisible = false;
      }
    }
  },
  watch: {
    open(newVal) {
      if(newVal) {
        this.dialogVisible = true;
      }
    },
    dialogVisible(newVal) {
      if(!newVal) {
      this.$emit('onChange', newVal);
      }
    }
  }
}
</script>

<style lang="scss" >
.modal-card-empty{
.el-select .el-input{
  width: 300px !important;
}
}

.dialog_empty_add{
.el-form-item span{
  padding: 0;
}

.el-input__suffix{
  right: -50px !important;
}
}

</style>